export const getRetailerCountSelector = (state) => state?.campaign?.count;
export const getViewCampaignData = (state) => state.campaign?.view;
export const getAssignmentsTableData = (state) => state?.campaign?.assignmentsTableData;
export const getAssignmentsData = (state) => state.campaign?.assignmentsData;
export const getRetailerAssignmentsTableData = (state) => state.campaign?.campaignRetailer;
export const getRetailerAssignmentsTablePagination = (state) => state.campaign.campaignRetailerPagination;
export const getDataCollectors = (state) => state.campaign.dataCollectors;
export const getMySecGeogs = (state) => state.campaign.mySecGeogs;
